import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import SeniorHealthWellnessDetails from '../../subdepartmentdetails/SeniorHealthWellness'


function SeniorHealthWellness() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Senior Health and Wellness Programs || Senior Services";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Senior Services"
            title="Senior Health Wellness"
            subtitledown="Department of Senior Services"
           />
            <SeniorHealthWellnessDetails/>
        </div>
    </>
  )
}

export default SeniorHealthWellness